import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const drawerWidth = 170

interface IStyleProps {
  isTitle?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  headerWrapper: {
    '&&': {
      paddingTop: SPACES.xxxxxl,
      paddingBottom: SPACES.l,

      [theme.breakpoints.up('laptop')]: {
        paddingLeft: SPACES.xxl,
        paddingRight: SPACES.xxl,
      },
    },
  },
  headerIconButton: {
    '&&': {
      paddingLeft: 0,
    },
  },
  headerIcon: {
    color: theme.palette.custom.darkBlue2,
  },
  iconWrapper: {
    '&&': {
      padding: 2,
    },
  },
  titleWrapper: ({ isTitle }: IStyleProps) => ({
    '&&': {
      marginBottom: isTitle ? SPACES.xxxxxl : '0px',

      color: theme.palette.custom.darkBlue2,
    },
  }),
  headerTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xxxxl,
      lineHeight: 1.375,
    },
  },
  headerDescr: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.357,
    },
  },
  headerCode: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
    },
  },
  headerBackdrop: {
    '&&': {
      color: theme.palette.custom.white,
      zIndex: 1001,
    },
  },
  headerDrawer: {
    '&&': {
      width: drawerWidth,
      flexShrink: 0,
      pl: SPACES.xxxxl,
    },
  },
  iconHolder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    maxWidth: '64px',
  },
  iconLogo: {
    maxHeight: '32px',
    height: '100%',
    width: 'auto',
    maxWidth: '64px',
    borderRadius: 0,
  },
}))

export default useStyles
